import { Component, OnInit } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { M2MDataStore } from './m2m-data-store';
import { __i18n } from '@localisation';
import { M2MDeviceStateTranslationService } from './m2m-device-state-translation.service';

@Component({
    templateUrl: './m2m-router.template.html',
    standalone: false
})
export class M2MRouterComponent implements OnInit {

    private deviceStateHeaderFilterValues: any[];
    public dataSource: DataSource;
    public equalFilter: string[] = ['='];
    public deviceStateHeaderFilterConfig: any;

    public constructor(
        private m2MDataStore: M2MDataStore,
        public m2MDeviceStateTranslationService: M2MDeviceStateTranslationService
    ) {
        this.deviceStateHeaderFilterValues = [
            'ActiveLive',
            'ActiveReady',
            'ActiveSleep',
            'ActiveStandby',
            'ActiveSuspend',
            'ActiveTest',
            //'InactiveNew', // obsolete
            'InactiveStopped',
            'InactiveTransformed',
            //'MigratedFromOtherGdspEnvironment',
            //'MigratedToOtherGdspEnvironment',
            //'NotProvisioned',
            'SuspendRegulatory',
            //'Terminated' // obsolete
        ].map((v) => {
            return {
                text: m2MDeviceStateTranslationService.getLocalizedDeviceState(v),
                value: v
            };
        });
        this.deviceStateHeaderFilterConfig = {
            dataSource: this.deviceStateHeaderFilterValues
        };
    }

    public ngOnInit(): void {
        this.dataSource = new DataSource({
            paginate: true,
            store: this.m2MDataStore.getStore({
                availableHeaderFilterValues: {
                    state: this.deviceStateHeaderFilterValues
                }
            })
        });
    }
}
